import { styled } from '@gogovan/entier-web-core/ext/mui/styles';

import gogoxSVG from '@/assets/gogox.svg';

const Container = styled('div')({
  direction: 'column',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

const GogoxIMG = styled(gogoxSVG)`
  height: 42px;
  margin-bottom: 58px;
`;

const paperStyles = {
  width: '408px',
  padding: '32px 16px 32px',
  display: 'flex',
  flexDirection: 'column',
  mb: '20px',
};

const textFieldStyles = {
  marginBottom: '16px',
};

const marginSelect = {
  mt: '20px',
};

const buttonStyles = {
  height: '42px',
};

// eslint-disable-next-line import/prefer-default-export
export { Container, GogoxIMG, paperStyles, textFieldStyles, marginSelect, buttonStyles };
